<template>
    <div class="language-switcher">
        <button
            v-for="language in languages"
            :key="language.code"
            :class="[
                'lang-button',
                { active: language.code === selectedLanguageCode },
            ]"
            @click="selectLanguage(language)"
        >
            <span class="flag">{{ language.flag }}</span>
            <span class="code">{{ language.code.toUpperCase() }}</span>
        </button>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useLanguagesStore } from "~/stores/languages";
import { useCookie } from "#app";

// i18n & Pinia
const { setLocale } = useI18n();
const languageStore = useLanguagesStore();

// Дефинисани језици
const languages = [
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "no", name: "Norsk", flag: "🇳🇴" },
];

// Стање
const languageCookie = useCookie("preferredLanguage");
const selectedLanguageCode = ref(languageCookie.value || "en");

// Избор језика
const selectLanguage = (language: {
    code: string;
    name: string;
    flag: string;
}) => {
    if (selectedLanguageCode.value !== language.code) {
        selectedLanguageCode.value = language.code;
        setLocale(language.code as "no" | "en");
        languageStore.setSelectedLanguage(language.code);
        languageCookie.value = language.code;
    }
};

// Иницијализација
onMounted(() => {
    const code = languageCookie.value;
    if (code && languages.some((lang) => lang.code === code)) {
        selectedLanguageCode.value = code;
        setLocale(code as "no" | "en");
        languageStore.setSelectedLanguage(code);
    }
});
</script>

<style scoped>
.language-switcher {
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
}

.lang-button {
    display: flex;
    align-items: center;
    gap: 6px;
    border: none;
    background-color: transparent;
    padding: 8px 14px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #888;
    transition: all 0.3s ease;
    transform: scale(1);
    opacity: 0.7;
}

.lang-button:hover {
    transform: scale(1.05);
    opacity: 1;
}

.lang-button.active {
    background-color: #ff8800;
    color: white;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transform: scale(1.08);
    opacity: 1;
}

.lang-button .flag {
    font-size: 18px;
}
</style>
